import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.LSError', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('http', false);
        tmp0_serialDesc.addElement_5pzumi_k$('detail', true);
        tmp0_serialDesc.addElement_5pzumi_k$('message', true);
        tmp0_serialDesc.addElement_5pzumi_k$('data', true);
        tmp0_serialDesc.addElement_5pzumi_k$('stackTrace', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_tem9sa_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.http_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.detail_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.detail_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.message_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.message_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.data_1 === '')) {
          tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 3, value.data_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.stackTrace_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, StringSerializer_getInstance(), value.stackTrace_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tem9sa_k$(encoder, value instanceof LSError() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LSError().new_com_lightningkite_lightningserver_LSError_1164md_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LSErrorClass;
function LSError() {
  if (LSErrorClass === VOID) {
    class $ {
      constructor(http, detail, message, data, stackTrace) {
        detail = detail === VOID ? '' : detail;
        message = message === VOID ? '' : message;
        data = data === VOID ? '' : data;
        stackTrace = stackTrace === VOID ? null : stackTrace;
        this.http_1 = http;
        this.detail_1 = detail;
        this.message_1 = message;
        this.data_1 = data;
        this.stackTrace_1 = stackTrace;
      }
      toString() {
        return 'LSError(http=' + this.http_1 + ', detail=' + this.detail_1 + ', message=' + this.message_1 + ', data=' + this.data_1 + ', stackTrace=' + this.stackTrace_1 + ')';
      }
      hashCode() {
        var result = this.http_1;
        result = imul(result, 31) + getStringHashCode(this.detail_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.message_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.data_1) | 0;
        result = imul(result, 31) + (this.stackTrace_1 == null ? 0 : getStringHashCode(this.stackTrace_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LSError()))
          return false;
        if (!(this.http_1 === other.http_1))
          return false;
        if (!(this.detail_1 === other.detail_1))
          return false;
        if (!(this.message_1 === other.message_1))
          return false;
        if (!(this.data_1 === other.data_1))
          return false;
        if (!(this.stackTrace_1 == other.stackTrace_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_LSError_1164md_k$(seen0, http, detail, message, data, stackTrace, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.http_1 = http;
        if (0 === (seen0 & 2))
          $this.detail_1 = '';
        else
          $this.detail_1 = detail;
        if (0 === (seen0 & 4))
          $this.message_1 = '';
        else
          $this.message_1 = message;
        if (0 === (seen0 & 8))
          $this.data_1 = '';
        else
          $this.data_1 = data;
        if (0 === (seen0 & 16))
          $this.stackTrace_1 = null;
        else
          $this.stackTrace_1 = stackTrace;
        return $this;
      }
    }
    initMetadataForClass($, 'LSError', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    LSErrorClass = $;
  }
  return LSErrorClass;
}
function MultiplexMessage$Companion$$childSerializers$_anonymous__okpt7() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), new (ArrayListSerializer())(StringSerializer_getInstance()));
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, lazy(tmp_0, MultiplexMessage$Companion$$childSerializers$_anonymous__okpt7), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.MultiplexMessage', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('channel', false);
        tmp0_serialDesc.addElement_5pzumi_k$('path', true);
        tmp0_serialDesc.addElement_5pzumi_k$('queryParams', true);
        tmp0_serialDesc.addElement_5pzumi_k$('start', true);
        tmp0_serialDesc.addElement_5pzumi_k$('end', true);
        tmp0_serialDesc.addElement_5pzumi_k$('data', true);
        tmp0_serialDesc.addElement_5pzumi_k$('error', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_avvx1g_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.channel_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.path_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, StringSerializer_getInstance(), value.path_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.queryParams_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.queryParams_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.start_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 3, value.start_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.end_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 4, value.end_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.data_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.data_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.error_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, StringSerializer_getInstance(), value.error_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_avvx1g_k$(encoder, value instanceof MultiplexMessage() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp12_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp12_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return MultiplexMessage().new_com_lightningkite_lightningserver_MultiplexMessage_8tr780_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[2].get_value_j01efc_k$()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var MultiplexMessageClass;
function MultiplexMessage() {
  if (MultiplexMessageClass === VOID) {
    class $ {
      constructor(channel, path, queryParams, start, end, data, error) {
        Companion_getInstance_0();
        path = path === VOID ? null : path;
        queryParams = queryParams === VOID ? null : queryParams;
        start = start === VOID ? false : start;
        end = end === VOID ? false : end;
        data = data === VOID ? null : data;
        error = error === VOID ? null : error;
        this.channel_1 = channel;
        this.path_1 = path;
        this.queryParams_1 = queryParams;
        this.start_1 = start;
        this.end_1 = end;
        this.data_1 = data;
        this.error_1 = error;
      }
      toString() {
        return 'MultiplexMessage(channel=' + this.channel_1 + ', path=' + this.path_1 + ', queryParams=' + toString(this.queryParams_1) + ', start=' + this.start_1 + ', end=' + this.end_1 + ', data=' + this.data_1 + ', error=' + this.error_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.channel_1);
        result = imul(result, 31) + (this.path_1 == null ? 0 : getStringHashCode(this.path_1)) | 0;
        result = imul(result, 31) + (this.queryParams_1 == null ? 0 : hashCode(this.queryParams_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.start_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.end_1) | 0;
        result = imul(result, 31) + (this.data_1 == null ? 0 : getStringHashCode(this.data_1)) | 0;
        result = imul(result, 31) + (this.error_1 == null ? 0 : getStringHashCode(this.error_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MultiplexMessage()))
          return false;
        if (!(this.channel_1 === other.channel_1))
          return false;
        if (!(this.path_1 == other.path_1))
          return false;
        if (!equals(this.queryParams_1, other.queryParams_1))
          return false;
        if (!(this.start_1 === other.start_1))
          return false;
        if (!(this.end_1 === other.end_1))
          return false;
        if (!(this.data_1 == other.data_1))
          return false;
        if (!(this.error_1 == other.error_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_MultiplexMessage_8tr780_k$(seen0, channel, path, queryParams, start, end, data, error, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.channel_1 = channel;
        if (0 === (seen0 & 2))
          $this.path_1 = null;
        else
          $this.path_1 = path;
        if (0 === (seen0 & 4))
          $this.queryParams_1 = null;
        else
          $this.queryParams_1 = queryParams;
        if (0 === (seen0 & 8))
          $this.start_1 = false;
        else
          $this.start_1 = start;
        if (0 === (seen0 & 16))
          $this.end_1 = false;
        else
          $this.end_1 = end;
        if (0 === (seen0 & 32))
          $this.data_1 = null;
        else
          $this.data_1 = data;
        if (0 === (seen0 & 64))
          $this.error_1 = null;
        else
          $this.error_1 = error;
        return $this;
      }
    }
    initMetadataForClass($, 'MultiplexMessage', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    MultiplexMessageClass = $;
  }
  return MultiplexMessageClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  LSError as LSError2xrpo13ez2d1,
  MultiplexMessage as MultiplexMessaged6a8e6rgamj7,
  $serializer_getInstance as $serializer_getInstance1jte6oocebacr,
  Companion_instance as Companion_instancezswcp2r1mhj0,
  Companion_getInstance_0 as Companion_getInstance1p6qahlqkjguh,
};
//endregion

//# sourceMappingURL=LSError.mjs.map
